function granteesCarousel() {
  document.addEventListener("DOMContentLoaded", () => {
    const carousel = document.getElementById("js-grantee-carousel");
    const prevButton = document.getElementById("js-grantee-carousel__prev");
    const nextButton = document.getElementById("js-grantee-carousel__next");

    if (!(carousel && (prevButton || nextButton))) {
      return;
    }

    function scrollCarousel(forwards) {
      const scrollAmount = window.innerWidth > 1023 ? 320 : 240;

      if (forwards) {
        carousel.scrollBy({ left: scrollAmount, behavior: "smooth" });
        return;
      }
      carousel.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    }

    prevButton.addEventListener("click", function () {
      scrollCarousel(false);
    });
    nextButton.addEventListener("click", function () {
      scrollCarousel(true);
    });
  });
}

export { granteesCarousel };
